import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "@vant/compat";
import useGetImage from "@/composiables/useGetImage";
import Cookies from "js-cookie";
// import useAddVideoPoster from "@/composiables/useAddVideoPoster";

axios.defaults.withCredentials = false;
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};

// let baseURL = process.env.VUE_APP_BASE_URL;
let baseURL = "https://zsrbapp.zsnews.cn";

console.log(baseURL);

export default createStore({
  state: {
    article: {
      model: {
        title: "",
        author: "",
        source: "",
        publicTime: "",
        linkUrl: ""
      }
    },
    photos: [],
    unionId: "",
    nickName: "",
    reporterList: [],
    relateList: [],
    infoList: [],
    infoListTotal: 0,
    votesDetail: {},
    userInfo: {},
    infoExtend: {}
  },
  mutations: {
    updateArticle(state, article) {
      // article.content = article.content.replace(/(?<=>) (?=<)/g, "&nbsp;");
      state.article = article;
      state.photos = useGetImage(article.content);
      // if (article.model.img) {
      //   state.article.content = useAddVideoPoster(
      //     article.content,
      //     article.model.img
      //   );
      // }

      // if (article.unionId) {
      //   state.unionId = article.unionId;
      // }

      if (article.nickName) {
        state.nickName = article.nickName;
      }
    },
    updateInfoExtend(state, infoExtend) {
      state.infoExtend = infoExtend;
    },
    updateReporterList(state, _list) {
      state.reporterList = _list;
    },
    updateRelateList(state, _list) {
      state.relateList = _list;
    },
    updateInfoList(state, _data) {
      state.infoList = _data.list;
      state.infoListTotal = _data.total;
    }
  },
  actions: {
    getArticle({ commit }, articleId) {
      return new Promise((resolve) => {
        axios
          .get(baseURL + "/api/news-detail/normal/" + articleId)
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 0) {
                commit("updateArticle", data.data);
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    getReporterList({ commit }, articleId) {
      return new Promise((resolve) => {
        axios
          .get(
            baseURL +
              "/api-v2/api/find-reporter/reporters/list-for-info/" +
              articleId
          )
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateReporterList", data.data);
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    //某个新闻对应的推荐新闻列表
    getRelateList({ commit }, articleId) {
      return new Promise((resolve) => {
        axios
          .get(
            baseURL +
              "/api-v2/api/information/news/relate-list-for-info/" +
              articleId
          )
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateRelateList", data.data);
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    //某个文章的评论列表
    getInfoList({ commit }, params) {
      return new Promise((resolve) => {
        axios
          .get(
            "https://zsplus-fastapi.zsnews.cn/api/plus/comment/list-for-info-preview/" +
              params.id +
              `?page=${params.page}` +
              `&page_size=${params.page_size}`,
            {
              headers: {
                sessionToken: sessionStorage.getItem("session_token")
              }
            }
          )
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateInfoList", data.data);
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    //获取用户点赞评论信息
    getInfoExtend({ commit }, id) {
      return new Promise(() => {
        axios
          .get("https://zsrbapp.zsnews.cn/api/info/extend?id=" + id, {
            headers: {
              sessionToken: sessionStorage.getItem("session_token")
            }
          })
          .then((res) => {
            console.log("getInfoExtend", res);
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 0) {
                commit("updateInfoExtend", data.data);
              }
            }
          });
      });
    },
    //文章预览
    getPreArticle({ commit }, articleId) {
      return new Promise((resolve) => {
        axios
          // .get(baseURL + "/api/illness/index")
          .get(baseURL + "/api/news-detail/preNormal/" + articleId)
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 0) {
                commit("updateArticle", data.data);
                resolve(data.data);
              } else if (data.code === 1) {
                tip(data.error);
              } else if (data.code === 401) {
                // token过期跳转获取新token
                Cookies.remove("token", { domain: ".zsnews.cn" });
                Cookies.remove("token");

                sessionStorage.removeItem("session_token");

                // 清除预览preview_token
                Cookies.remove("preview_token", { domain: ".zsnews.cn" });
                Cookies.remove("preview_token");
                window.location.href =
                  "https://zsrbapp.zsnews.cn/api/news-detail/auth/" + articleId;
              } else {
                tip(data);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    }
  },
  modules: {}
});
